// extracted by mini-css-extract-plugin
export var square = "Square-module--square--LyCYZ";
export var opacityAnime = "Square-module--opacityAnime--l5rVP";
export var square__icon = "Square-module--square__icon--3Zn_6";